import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { Flex } from "reflexbox";
import Button from "../Button";
import { Heading, Body } from "../Text";

const HeadingSection = ({
  hideBack = false,
  hideCreate = false,
  backButtonIcon = "faArrowLeft",
  backButtonLink: _backButtonLink,
  additionalElements,
  inlineAdditionalElements = false,
  title,
  centerTitle = false,
  centerSubtitle = false,
  rightSubtitle = false,
  boldSubtitle = false,
  subtitle,
  createButton,
  createButtonColor,
  createButtonText,
  createButtonIcon,
  createLink: _createLink,
  createButtonDisabled,
  backButtonColor,
  ...rest
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const createLink = () => {
    let key = "to";
    if (typeof _createLink === "function") key = "onClick";
    if (!_createLink) return { onClick: () => navigate(-1) };
    return { [key]: _createLink };
  };

  const backButtonLink = useMemo(() => {
    let key = "to";
    if (typeof _backButtonLink === "function") key = "onClick";
    if (!_backButtonLink) return { onClick: () => navigate(-1) };
    return { [key]: _backButtonLink };
  }, [_backButtonLink, navigate]);

  return (
    <Flex {...rest} style={{ gap: "1rem" }} flexDirection="column" width={1}>
      <Flex
        width={1}
        flexDirection={["column", "column", "row"]}
        style={{ gap: "1rem" }}
        flexWrap="wrap"
        alignItems={["center", "center", "center"]}
        justifyContent={centerTitle ? "space-between" : "flex-start"}
      >
        {(title || !hideBack) && (
          <Flex alignItems="center" width={1}>
            <Flex
              style={{ gap: "1rem" }}
              justifyContent="flex-start"
              flex={centerTitle ? 1 : undefined}
            >
              {!hideBack && (
                <Button
                  size="small"
                  reverse
                  color={backButtonColor || theme.gray}
                  iconName={backButtonIcon}
                  {...backButtonLink}
                />
              )}
            </Flex>
            {title && (
              <Heading
                ml={!hideBack ? "1rem" : undefined}
                style={{
                  width: centerTitle ? "auto" : undefined,
                  flex:
                    centerTitle || (!title && !hideBack) || (hideBack && title)
                      ? 1
                      : undefined,
                }}
                center={centerTitle}
              >
                {title}
              </Heading>
            )}

            {additionalElements && !inlineAdditionalElements ? (
              <Flex
                display={["none", "none", "flex"]}
                flex={
                  centerTitle || (!title && !hideBack) || (hideBack && title)
                    ? 1.2
                    : undefined
                }
                style={{ gap: "1rem" }}
                alignItems="center"
              >
                {additionalElements}
              </Flex>
            ) : null}
            <Flex justifyContent="flex-end" flex={centerTitle ? 1 : undefined}>
              {inlineAdditionalElements ? additionalElements : null}
              {!hideCreate && !createButton && (
                <Button
                  m="0"
                  ml="1rem"
                  disabled={createButtonDisabled}
                  iconName={createButtonIcon}
                  color={createButtonColor || theme.callToActionColor}
                  {...createLink()}
                >
                  {createButtonText && <Body>{createButtonText}</Body>}
                </Button>
              )}
              {createButton}
            </Flex>
          </Flex>
        )}
        {additionalElements && !inlineAdditionalElements ? (
          <Flex
            display={["flex", "flex", "none"]}
            flex={
              centerTitle || (!title && !hideBack) || (hideBack && title)
                ? 1.2
                : undefined
            }
            style={{ gap: "1rem" }}
            alignItems="center"
          >
            {additionalElements}
          </Flex>
        ) : null}
      </Flex>

      {subtitle && (
        <Body
          bold={boldSubtitle}
          right={rightSubtitle}
          center={centerSubtitle}
          m={0}
        >
          {subtitle}
        </Body>
      )}
    </Flex>
  );
};

export default HeadingSection;
